import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { BillingFeature } from 'webapp/enums/enums';

import type { EmptyScreensBaseArgs } from 'webapp/components/empty-screens/base';
import EmptyScreensBaseComponent from 'webapp/components/empty-screens/base';

export default class EmptyScreensBoardLoopsComponent extends EmptyScreensBaseComponent<EmptyScreensBaseArgs> {
	@service('analytics') declare analyticsService: Service.Analytics;
	@service('flow/tour/onboarding')
	declare flowTourOnboardingService: Service.Flow.Tour.Onboarding;
	@service('model-manager/boards') declare mmBoardsService: Service.ModelManager.Boards;
	@service('model-manager/board-loops')
	declare mmBoardsLoopService: Service.ModelManager.BoardLoops;

	trackingOrigin = 'loops';

	constructor(owner: Owner, args: EmptyScreensBaseArgs) {
		super(owner, args);

		this.titleText = 'Group multiple dashboards together';
		this.descText = 'Get a comprehensive view of your performance.';
		this.topImageLightUrl = '/images/placeholders/loops.svg';
		this.topImageDarkUrl = '/images/placeholders/dark/loops.svg';

		this.trialFeatures = [BillingFeature.BOARD_LOOPS];

		this.imageLightUrl = '/images/placeholders/placeholder-loops.svg';

		this.readMoreUrl = 'https://help.databox.com/overview-looped-databoards';

		this.mainActions = [
			{
				action: this.create,
				icon: 'Plus',
				text: 'New loop',
				isForCreating: true,
			},
		];

		if (this.accountService.showPublicTemplates) {
			this.mainActions.push({
				action: this.openPublicTemplates,
				icon: 'FolderOpen',
				text: 'Use a template',
			});
		}

		this.arrowText = 'Click here to get started with your first loop';
	}

	override get isNewSectionShown() {
		return (
			this.isAnyActionShown &&
			!this.mustUpgrade &&
			!this.isCurrentUserViewer &&
			this.mmBoardsService.normalBoardModels.length > 0
		);
	}

	@action
	override create(): void {
		this.mmBoardsLoopService.createNewWithTracking();
	}

	@action
	openPublicTemplates() {
		this.navigationService.transitionToRoute('boards.public-templates').then(() => {
			window.location.hash = 'all|all|2';
		});
	}
}
